<template>
    <div>
        <div class="depositCertificateBox">
            <div class="depositCertificate">
                <p>存证量</p>
                <div class="today">
                    <p>今日存证:</p>
                    <span>15</span>
                </div>
            </div>
            <div class="echart" id="mychart" :style="myChartStyle"></div>
        </div>
    </div>
</template>

<script>
    import * as echarts from "echarts";
    export default {
        name: "histogram",
        data() {
            return {
                xData: ["05", "06", "07", "08", "09"], //横坐标
                yData: [23, 24, 18, 25, 27, 28, 25], //数据
                myChartStyle: { width: "100%", height: "380px" } //图表样式
            };
        },
        mounted() {
            this.initEcharts();
        },
        methods: {
            initEcharts() {
                // 基本柱状图
                const option = {
                    xAxis: {
                        data: this.xData,
                        name:'月份'
                    },
                    yAxis: {
                        name:'套数'
                    },
                    series: [
                        {
                            type: "bar", //形状为柱状图
                            data: this.yData,
                            barWidth : 30,//柱图宽度
                            itemStyle:{ normal:{ color:'#3c60f1' } }
                        },
                    ]
                };
                const myChart = echarts.init(document.getElementById("mychart"));
                myChart.setOption(option);
                //随着屏幕大小调节图表
                window.addEventListener("resize", () => {
                    myChart.resize();
                });
            }
        }
    }
</script>

<style scoped>
    .depositCertificateBox{
        margin-top: 10px;
        padding: 13px 10px;
    }
    .depositCertificate{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .depositCertificate>p{
        font-weight: 600;
    }
    .today{
        display: flex;
        align-items: flex-end;
    }
    .today>p{
        font-weight: 600;
    }
    .today>span{
        font-size: 22px;
        font-weight: 600;
        color: #5660d7;
    }
</style>
